import { routerPath } from '@/shared/config/router';

/** Вкладка заявок на удаление на странице Profiles: `?tab=deletions`. */
export const PROFILES_TAB_PARAM = 'tab';
export const PROFILES_DELETIONS_TAB = 'deletions';

/** Фильтр «Needs attention» вкладки: `&attention=1` — только заявки, которым нужен человек. */
export const DELETIONS_ATTENTION_PARAM = 'attention';

/** Куда ведёт счётчик проблемных заявок — в меню и на вкладке. */
export const DELETIONS_ATTENTION_HREF = `${routerPath.profiles}?${PROFILES_TAB_PARAM}=${PROFILES_DELETIONS_TAB}&${DELETIONS_ATTENTION_PARAM}=1`;
